import { jsonApi } from '@models/jsonApi';

jsonApi.define('privacy/privacy', {
    id: null,
    label: null,
    privacy_template: null,
    hosting_type: null,
    hosting_path: null,
    embed_iab: null,
    created: null,
});
